import React, { Component } from 'react';
import Link from 'gatsby-link';
import classNames from 'classnames';

export class SidebarMenu extends Component {
  render() {
    return (
      <nav className="sidebarMenu" id={this.props.id || 'menu'}>
        <a href="#" className="sidebarMenu__close">
          <span className="glyphicon glyphicon-remove" />
        </a>

        <ul className="sidebarMenu__items">
          <li>
            <a href="/">Domů</a>
          </li>
          {(this.props.links || []).map(link => {
            return (
              <li>
                <Link to={link.href}>{link.title}</Link>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}

export default SidebarMenu;



// WEBPACK FOOTER //
// ./src/components/SidebarMenu.js